import { render, staticRenderFns } from "./bookCard.vue?vue&type=template&id=d75e5646&scoped=true"
import script from "./bookCard.vue?vue&type=script&lang=js"
export * from "./bookCard.vue?vue&type=script&lang=js"
import style0 from "./bookCard.vue?vue&type=style&index=0&id=d75e5646&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75e5646",
  null
  
)

export default component.exports